import { ChangeEvent, useCallback } from 'react';
import {
  SxProps,
  TablePagination as MUITablePagination,
  TablePaginationProps as MUITablePaginationProps,
} from '@mui/material';

import layout from '@atom/styles/layout';

type CustomProps = {
  /**
   * 1 based index number of current page
   */
  page: number;
  onPageChange: (page: number) => void;
  /**
   * width of the pagination component.
   * since it is absolutely positioned percentage widths reflect percentage of the entire viewport.
   * defaults to calc(100vw - layout.sidePaneWidth)
   */
  width?: string | number;
};

type AtomMUIProps = {
  rowsPerPageOptions?: number[];
  'data-cy'?: string;
  count: number;
  rowsPerPage: number;
  onRowsPerPageChange?: (event: any) => void;
};

export type TablePaginationProps = CustomProps & AtomMUIProps;

const TablePagination = (props: TablePaginationProps) => {
  const {
    page,
    onPageChange,
    width = `calc(100vw - ${layout.sidePaneWidth})`,
    ...data
  } = props;

  const sx: SxProps = {
    '& .MuiTablePagination-toolbar': {
      padding: 0,
      width,
    },
  };

  const MUIProps: Omit<MUITablePaginationProps, 'page' | 'onPageChange'> = data;

  const handlePageChange = useCallback(
    (event: ChangeEvent<any>, updatedPage: number) => {
      onPageChange(updatedPage + 1);
    },
    [onPageChange],
  );

  return (
    <MUITablePagination
      page={page - 1}
      onPageChange={handlePageChange}
      sx={sx}
      {...MUIProps}
    />
  );
};

export default TablePagination;
